import { CertificationDTO } from "./certification.dto";
import { Injectable } from "@nestjs/common";
import { Certifications } from "../certifications.entity";

@Injectable()
export class CertificationAdapter{
     
    public convertDtoToEntity(dto: CertificationDTO, isUpdate: boolean = false): Certifications{
        const entity = new Certifications();
        entity.certificationId = dto.certificationId;
        entity.certification = dto.certification;
        entity.isActive = dto.isActive == undefined ? true: dto.isActive;
        if(isUpdate){
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.isActive = true;
            entity.createdUser = dto.createdUser;
        }
        return entity;
    }

    public convertEntityToDto(entity: Certifications): CertificationDTO{
        const dto = new CertificationDTO;
        dto.certificationId = entity.certificationId;
        dto.certification = entity.certification;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;
    }
}